import React from 'react';
import { BarChart as MuiBarChart } from '@mui/x-charts/BarChart'; // Renombrado para evitar conflicto
import { Box, Typography } from '@mui/material';
import { useApiTrigger } from '../../hooks/useApiTrigger';

const parseSingleSeriesData = (rawData) => {
    const categories = rawData.map(item => item.category);
    const dataValues = rawData.map(item => item.value);
    const colorPalette = ['#02B2AF', '#2E96FF', '#B800D8', '#60009B'];
    const colors = rawData.map((item, index) => item?.color ? item?.color : colorPalette[index % colorPalette.length]);

    return {
        categories,
        dataValues,
        colors
    };
};

const BarChart = ({ data, filters }) => {
    const { dto: dtoChart } = useApiTrigger(data, filters);
    const dto = parseSingleSeriesData(dtoChart);
    const defaultBarColor = '#673AB7';

    return (
        <Box
            sx={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column', p: 1 }}
        >
            <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ height: 36, mb: 2 }}>
                <Typography fontWeight={500} noWrap>
                    {data.accion}
                </Typography>
                {/* <IconButton size="small">
                    <InfoOutlined sx={{ fontSize: 16 }} />
                </IconButton> */}
            </Box>

            <MuiBarChart
                xAxis={[{
                    scaleType: 'band',
                    data: dto.categories,
                    categoryGapRatio: 0.4,
                }]}
                series={[{
                    data: dto.dataValues,
                    // label: 'Cantidad de facturas',
                    color: defaultBarColor,
                    barLabel: 'value',
                }]}
                grid={{ horizontal: true }}
                slotProps={{
                    barLabel: { display: 'none' },
                    bar: (props) => ({
                        fill: dto.colors[props.dataIndex] ?? defaultBarColor,
                        rx: 2,
                    }),
                    legend: {
                        direction: 'row',
                        position: { vertical: 'bottom', horizontal: 'middle' },
                        itemMarkWidth: 10,
                        itemMarkHeight: 10,
                        labelStyle: { fontSize: 12 },
                    }
                }}
                margin={{ left: 0, right: 1, top: 1, bottom: 3 }}
                sx={{
                    '& .MuiChartsGrid-line': { strokeDasharray: '5 5', stroke: 'divider' },
                    '& .MuiChartsAxis-line': { stroke: 'black' }, // Línea base resaltada
                }}
            />
        </Box>
    );
};

export default BarChart;